import { FC, PropsWithChildren, ReactNode } from 'react';
import { Box, Stack , Typography } from '@mui/material';


type Props = PropsWithChildren<{
  title: ReactNode
  subtitle: ReactNode
  description: ReactNode
}>

export const Step: FC<Props> = ({ title, subtitle, description, children }) => {
  return (
    <Box bgcolor="#f1f3f480" p={4} border={1} borderColor="#dce2e5" borderRadius="8px" flex={1}>
      <Stack spacing={2} alignItems="center" textAlign="center" height="100%">
        <Typography variant="h2" fontWeight={600}>{title}</Typography>
        <Typography fontStyle="italic">{subtitle}</Typography>
        <Typography variant="caption" color="textSecondary">{description}</Typography>
        <Box display="flex" flexDirection="column" flexGrow={1} justifyContent="end">
          {children}
        </Box>
      </Stack>
    </Box>
  );
};
